export enum DeliveryType {
  NONE = 'NONE',
  EMAIL = 'EMAIL',
  PRINT = 'PRINT',
  EINVOICE = 'EINVOICE',
  SMS = 'SMS',
}
